const money = (value) => value === null || value === undefined
  ? 'Unlimited'
  : `₹${Number(value || 0).toLocaleString('en-IN')}`;

const TeamRows = ({ teams = [], purse = false }) => (
  <div className="d-grid gap-2">
    {teams.map((team) => (
      <div className="border rounded p-2" key={team.id || team.name}>
        <strong>{team.name}</strong>
        <div className="small text-muted">
          {purse
            ? `${money(team.originalPurse)} · spent ${money(team.spent)} · remaining ${money(team.remainingPurse)} · ${team.playerCount}/${team.teamCapacity}`
            : `${team.playerCount || 0} players · ${money(team.remainingPurse)} remaining`}
        </div>
      </div>
    ))}
  </div>
);

const AuctionScenePreview = ({ model, label }) => {
  const scene = model?.scene || 'none';
  const player = model?.player;
  let content = <div className="text-muted">No scene selected.</div>;
  if (['player_profile', 'current_bid', 'sold', 'unsold'].includes(scene)) {
    content = (
      <>
        <div className="fw-bold fs-5">{player?.name || 'Player'}</div>
        <div className="small text-muted">{player?.role}</div>
        {scene === 'current_bid' ? <div>{money(model?.bid?.amount)} · {model?.bid?.leadingTeam?.name || 'No leading team'}</div> : null}
        {scene === 'sold' ? <div className="text-success fw-bold">SOLD · {model?.sold?.team} · {money(model?.sold?.amount)}</div> : null}
        {scene === 'unsold' ? <div className="text-danger fw-bold">UNSOLD</div> : null}
      </>
    );
  } else if (scene === 'team_squad') {
    content = <><TeamRows teams={model?.team ? [model.team] : []} /><div className="small mt-2">{(model?.team?.squad || []).map((item) => item.name).join(', ')}</div></>;
  } else if (scene === 'purse_table') {
    content = <TeamRows teams={model?.purseTable} purse />;
  } else if (scene === 'teams_formed' || scene === 'auction_completed') {
    content = <><div className="fw-bold mb-2">{scene === 'auction_completed' ? 'Auction completed' : 'Teams formed'}</div><TeamRows teams={model?.teamsFormed || model?.completion?.teams} /></>;
  } else if (scene === 'auction_progress') {
    content = <div>Round {model?.progress?.round || 1} · {model?.progress?.phase} · {model?.progress?.counts?.pending || 0} pending</div>;
  } else if (scene === 'break' || scene === 'custom_message') {
    content = <><div className="fw-bold">{model?.customMessage?.title || 'Break'}</div><div>{model?.customMessage?.subtitle}</div></>;
  }
  return (
    <div className="border rounded-3 p-3 bg-dark text-white h-100" data-scene={scene}>
      <div className="small text-info text-uppercase mb-2">{label} · {scene.replaceAll('_', ' ')}</div>
      {content}
    </div>
  );
};

export default AuctionScenePreview;
